// @flow
import env from '../../environment';
import {getCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_CONTACT: `${env.baseApiUrl}/ui/admin/store/contact`,
  GET_CONTACT_TYPES: `${env.baseApiUrl}/ui/admin/store/contact-types`,
  GET_SOCIAL: `${env.baseApiUrl}/ui/admin/store/social-media`,
  GET_SOCIAL_MEDIA_TYPES: `${env.baseApiUrl}/ui/admin/store/social-media-types`,
  GET_SCHEDULE_SHIPMENT: `${env.baseApiUrl}/ui/admin/store/schedule-shipment`,
  GET_PAYMENT_METHODS: `${env.baseApiUrl}/ui/admin/store/paymenth-methods`,
});

export const getContactApi = getCreator(endpoints.GET_CONTACT);
export const getContactTypesApi = getCreator(endpoints.GET_CONTACT_TYPES);
export const getSocialApi = getCreator(endpoints.GET_SOCIAL);
export const getSocialMediaTypesApi = getCreator(
  endpoints.GET_SOCIAL_MEDIA_TYPES
);
export const getPaymentMethodsApi = getCreator(endpoints.GET_PAYMENT_METHODS);
export const getScheduleShipmentApi = getCreator(
  endpoints.GET_SCHEDULE_SHIPMENT
);
